<template>
  <video
    :id="`video${_uid}`"
    :ref="`video${_uid}`"
    class="afb-video"
    @click="() => playVid(!play)"
    playsinline
    loop="true"
    :controls="controls"
    muted="muted"
    :src="source"
  />
</template>
<script>
export default {
  name: "AFBVideo",
  props: {
    source: {
      type: String,
      default: "",
    },
    controls: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      play: false,
      loaded: false,
    };
  },
  methods: {
    playVid(val) {
      const videoEl = document.getElementById(`video${this._uid}`);
      if (val) {
        videoEl.play();
      } else {
        videoEl.pause();
      }
    },
  },
  mounted() {
    //const videoEl = this.$refs[`video${this._uid}`];
    // use this to let know parent component when data is loaded
    //videoEl.onloadeddata = () => this.$emit("onLoadEvent", true);
  },
};
</script>
<style>
video {
  width: 100%;
}
</style>
